/* eslint-disable camelcase */
// third-party
import { createSlice } from '@reduxjs/toolkit';
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    isLoading: false,
    nextPageUrl: null,
    commentsList: [],
    reqCode: null,
    bookingCode: null,
    quoteCode: null,
    bookingPriceInINR: null,
    reqStatus: null,
    quotesList: [],
    quoteListWithPriceAndCurrency: {},
    selectedQuote: {},
    isScrollToBottom: true
};

const slice = createSlice({
    name: 'reqComments',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // SET REQUIREMENT DETAILS
        setReqDetails(state, action) {
            const { booking_details = {}, current_status = {}, code: reqCode } = action.payload;
            const { booking_code = null, quote_code = null, booking_price_in_inr = null } = booking_details || {};
            state.reqCode = reqCode;
            state.bookingCode = booking_code;
            state.quoteCode = quote_code;
            state.bookingPriceInINR = booking_price_in_inr;
            state.reqStatus = current_status;
        },

        // SET COMMENT
        setComments(state, action) {
            const { data = {}, isRefresh = false } = action.payload;
            const { next = null, results = [] } = data || {};
            if (isRefresh) {
                state.commentsList = results;
                state.isScrollToBottom = true;
            } else {
                state.commentsList = [...results, ...state.commentsList];
                state.isScrollToBottom = false;
            }
            state.nextPageUrl = next;
            // state.error = null;
        },

        // SET NEW COMMENT
        addNewComment(state, action) {
            const newComment = action.payload;
            state.commentsList = [...state.commentsList, newComment];
            state.isScrollToBottom = true;
            state.error = null;
        },

        // SET QUOTESLIST
        setQuotesList(state, action) {
            const { results = [] } = action.payload;
            const obj = {};
            results.forEach((quote) => {
                const { code = null } = quote || {};
                obj[code] = quote;
            });
            state.quoteListWithPriceAndCurrency = obj;
            state.quotesList = results;
        },

        // SET SELECTED QUOTE
        setSelectedQuote(state, action) {
            const { bookingCode = null, quoteCode = null, quoteDetails = null } = action.payload;
            const temp = state.quotesList.filter((quote) => quote.code === quoteCode)[0];
            if (bookingCode && quoteCode) {
                state.selectedQuote = temp;
            } else if (!bookingCode) {
                state.selectedQuote = quoteDetails;
            } else state.selectedQuote = {};
        },

        setIsLoading(state, action) {
            const { loadingField = '', isLoading = false } = action.payload || {};
            state[loadingField] = isLoading;
        }
    }
});

export default slice.reducer;

export function getRequirementDetails(reqCode = null) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/requirements/${reqCode}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setReqDetails(response.data));
        } catch (err) {
            dispatch(slice.actions.hasError(err));
        }
    };
}

export function getQuotesList(reqCode = null) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/requirements/${reqCode}/quotes`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setQuotesList(response.data));
        } catch (err) {
            dispatch(slice.actions.hasError(err));
        }
    };
}

export function getComments(nextPageUrl = null, reqCode = null, isRefresh = false) {
    return async () => {
        if (!isRefresh && !nextPageUrl) return;
        let url = `${ARYABHATTA_API_DOMAIN_V1}all/comments/requirements/${reqCode}`;
        if (nextPageUrl && !isRefresh) url = nextPageUrl;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            const { error = null } = response.data;
            if (error) dispatch(slice.actions.hasError(error));
            else dispatch(slice.actions.setComments({ data: response.data, isRefresh }));
        } catch (err) {
            dispatch(slice.actions.hasError(err));
        }
    };
}

export function postComment(reqCode = null, bookingCode = null, quoteCode = null, formData = null) {
    return async () => {
        let url = '';
        if (!(bookingCode || quoteCode)) {
            url = `${ARYABHATTA_API_DOMAIN_V1}acm/comments/requirements/${reqCode}/`;
        } else {
            url = `${ARYABHATTA_API_DOMAIN_V1}acm/comments/requirements/${reqCode}/${
                quoteCode ? `quotes/${quoteCode}` : `bookings/${bookingCode}`
            }/`;
        }
        try {
            const response = await axios.post(url, formData);
            dispatch(slice.actions.addNewComment(response.data));
        } catch (err) {
            dispatch(slice.actions.hasError(err));
        }
    };
}

export function selectQuote(bookingCode = null, quoteCode = null, quoteDetails = null) {
    return async () => dispatch(slice.actions.setSelectedQuote({ bookingCode, quoteCode, quoteDetails }));
}
